import { WSQueryConfig } from "@ws-react-query";
import { IRateCard } from "@wingspanhq/payments/dist/interfaces";
import { getRateCard } from "../../../services/rateCards/getRateCard";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";
import { QUERY_RATE_CARD } from "../keys";

export const useQueryRateCard = (
  rateCardId: string,
  config?: WSQueryConfig<IRateCard, WSServiceError>
) => {
  return useWSQuery<IRateCard, WSServiceError>(
    [QUERY_RATE_CARD, rateCardId],
    async () => {
      return await getRateCard(rateCardId);
    },
    {
      ...config
    }
  );
};
